export class TimeoutError extends Error {
    constructor() {
        super('Timeout has timed out')
    }
}

export function timeout(time: number) {
    return new Promise<void>((resolve) => setTimeout(resolve, time))
}

export function rejectTimeout<T>(time: number) {
    return new Promise<T>((_, reject) => setTimeout(() => reject(new TimeoutError()), time))
}
